import { styled } from '../../styled-components';

export const UiColorGreen = styled.div.attrs({ className: 'UiColorGreen' })`
  color: ${p => p.theme.colorGreen};
`;
